import colorPattern from '../../../colors'

const darkFontColors = {
    'font-primary': colorPattern.pearl,
    'font-secondary': colorPattern.moon,
    'font-invert': colorPattern.onyx,
    'font-brand-primary': colorPattern.sky,
    'font-brand-secondary': colorPattern.violet,
} as const

export default darkFontColors
